import React from 'react';
import { ITranslateProps, translate } from '../../mixins/translate';

export interface IFmecaRiskLabelProps extends ITranslateProps {
    weightedValue?: undefined | string;
    totalValue?: undefined | string;
}

class FmecaRiskLabelComponent extends React.Component<IFmecaRiskLabelProps, Record<string, unknown>> {
    public override render() {
        if (this.props.weightedValue && this.props.weightedValue !== '0' && this.props.weightedValue !== 'null') {
            return (
                <span className={`label p5 fs11 rams_result${this.props.weightedValue}`}>
                    {' '}
                    {this.props.t(`fmecaRisk.${this.props.weightedValue}`)}
                    {this.props.totalValue && <>&nbsp;({this.props.totalValue}) </>}
                </span>
            );
        }
        return <span />;
    }
}

// eslint-disable-next-line @typescript-eslint/naming-convention
export const FmecaRiskLabel = translate()(FmecaRiskLabelComponent);
